import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../../common/breadcrumbs";
import Loader from "../../../common/loader";
import { capitalizeFirstLetter, currencyCovMap, formateDate } from "../../../../../utils/commonfunction";
import * as reportService from "../../../services/reports.service";
import { useTranslation } from "react-i18next";

const RedemptionReportView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "Redemption", url: "/admin/reports/redemption-report/list/1" },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    reportService
      .DetailsRedemptionreport(params._id)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : {});
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">View Redemption Details</h6>
              </div>

              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table id="simple-table" className="table table-bordered table-hover">
                      <tbody>
                        <tr>
                          <th>User Name</th>
                          <td className="text-capitalize">{capitalizeFirstLetter(showdefault.user?.fullName) || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>User Email</th>
                          <td className="text-capitalize">{capitalizeFirstLetter(showdefault.user?.email) || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Business User Name</th>
                          <td className="text-capitalize">{capitalizeFirstLetter(showdefault?.business?.business_name) || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Business User Email</th>
                          <td>{capitalizeFirstLetter(showdefault?.business?.email) || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Offer Name</th>
                          <td className="text-capitalize">{(showdefault.offer && showdefault.offer[0].name) || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Net Pay Amount</th>
                          <td className="text-capitalize">{currencyCovMap[showdefault.currency.toUpperCase()] ?? '$'} {showdefault.netPay || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Discount Amount</th>
                          <td className="text-capitalize">{currencyCovMap[showdefault.currency.toUpperCase()] ?? '$'} {showdefault.discountAmount || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Total Amount</th>
                          <td className="text-capitalize">{currencyCovMap[showdefault.currency.toUpperCase()] ?? '$'}  {showdefault.totalAmount || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Reference ID</th>
                          <td className="text-capitalize">{showdefault.transactionID || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("Created Date")}</th>
                          <td>{showdefault.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="mt-5">
                      <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        back
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RedemptionReportView;
